Cart={
  Update_cart_count(){
    jQuery.getJSON('/cart.js', function(cart) {
      $('[data-cart-count]')[0].innerHTML=cart.item_count;
      $('[data-cart-count]')[0].removeAttribute("style")
    } );
  },
  Update_cart_popup(){
    $(document).find($('.header-cart.js-header-cart .header-cart__inner')).addClass('loading');
    fetch('/').then(function (response) {
      return response.text();
    }).then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var cart_content = doc.querySelector('.js-header-cart').querySelector('.js-cart-popup-content').innerHTML

      $('.js-header-cart').find($('.js-cart-popup-content'))[0].innerHTML=cart_content;
      Cart.headerCartPosition();
      Cart.headerCartPosition();
      $(document).find($('.header-cart.js-header-cart .header-cart__inner')).removeClass('loading');
    }).catch(function (err) {
      console.error('Something went wrong.', err);
    });
    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
  setTimeout(function(){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
  },800);
    }
  },
  headerCartPosition() {
    var $headerCartHead = $(".js-header-cart-head");
    var $headerCartBody = $(".js-header-cart-body");
    var $headerCartFooter = $(".js-header-cart-footer");
    var $headerCartEmpty = $(".js-header-cart-empty");
    var conatinerWidth = $(".container").css("max-width");
    var $headerCartHeadInner = $headerCartHead.find(".header-cart__head__inner");
    var $headerCartBox = $headerCartBody.find(".header-cart__box");
    var $headerCartFooterInner = $headerCartFooter.find(".header-cart__footer__inner");
    var $headerCartEmptyInner = $headerCartEmpty.find(".header-cart__empty__inner");
    var maxWidth = 528 + (document.documentElement.clientWidth - conatinerWidth.slice(0, conatinerWidth.length - 2)) / 2 + 40;
    var paddingRight = (document.documentElement.clientWidth - conatinerWidth.slice(0, conatinerWidth.length - 2)) / 2;
    if (window.matchMedia("(min-width: 768px)").matches) {
      $headerCartHeadInner.css("width", maxWidth + "px");
      $headerCartHeadInner.css("padding-left", "40px");
      $headerCartHeadInner.css("padding-right", paddingRight + "px");
      $headerCartFooterInner.css("width", "" + maxWidth);
      $headerCartFooterInner.css("padding-left", "40px");
      $headerCartFooterInner.css("padding-right", paddingRight + "px");
      $headerCartBox.css("width", "" + maxWidth);
      $headerCartBox.css("padding-left", "40px");
      $headerCartBox.css("padding-right", paddingRight + "px");
      $headerCartEmptyInner.css("padding-left", "150px");
      $headerCartEmptyInner.css("padding-right", paddingRight + 87 + "px")
    } else {
      $headerCartHeadInner.css("width", "100%");
      $headerCartHeadInner.css("padding-left", "24px");
      $headerCartHeadInner.css("padding-right", "24px");
      $headerCartFooterInner.css("width", "100%");
      $headerCartFooterInner.css("padding-left", "24px");
      $headerCartFooterInner.css("padding-right", "24px");
      $headerCartBox.css("width", "100%");
      $headerCartBox.css("padding-left", "24px");
      $headerCartBox.css("padding-right", "24px");
      $headerCartEmptyInner.css("padding-left", "24px");
      $headerCartEmptyInner.css("padding-right", "24px")
    }
  },
  Update_cart(){
    $(document).find($('.cart-items_wrapper')).addClass('loading');
    fetch('/cart').then(function (response) {
      return response.text();
    }).then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var cart_content = doc.querySelector('.cart-items').querySelector('.js-cart-content').outerHTML
      var cart_left_bar = doc.querySelector('.cart-items').querySelector('.cart-items_left').outerHTML
      var shiping = doc.querySelector('.cart-shipping').style.display

      $('.cart-items').find($('.js-cart-content'))[0].outerHTML=cart_content;
      $('.cart-items').find($('.cart-items_left'))[0].outerHTML=cart_left_bar;
      $('.cart-shipping').css('display',shiping);
      $('body').removeClass("modal-open");
      $('body').css("padding","0");
      $('.modal-backdrop.fade.show').remove();
      $(document).find($('.cart-items_wrapper')).removeClass('loading');
    }).catch(function (err) {
      console.error('Something went wrong.', err);
    });
    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
  setTimeout(function(){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
  },800);
    }

  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
window.addEventListener("scroll", function () {
  const deviceHeight      =   `${window.innerHeight}px`
  console.log ( 'deviceHeight', deviceHeight );
  // header
  // const $header           =   $("#header");
  const $header           =   $(".top-new-header__wrapper");
  const headerHeight      =   $header.height();

  // preheader
  // const $preheader        =   $("#preheader");
  const $preheader        =   $(".top-new-header__mega-menu");
  const preheaderHeight   =   $preheader.height();
  // scroll value
  const scrollValue       =   window.pageYOffset;

  const scrollTopPosition =   $( window ).scrollTop();

  const screenWidth       =   $( window ).width();

  if ( screenWidth > 991 ) {
    if ( scrollTopPosition > 500 ) {
      $( `.product-fixed` ).addClass( `showDiv` );
    } else {
      $( `.product-fixed` ).removeClass( `showDiv` );
    }
  }

  // main
  // const $main = $("#main");
  // $main.css("margin-top", headerHeight);

  // header catalog
  const $headerCatalog    =   $(".js-header-catalog");
  const $headerCatalogList =  $(".js-header-catalog-block");
  // header Cart
  const $headerCart       =   $(".js-header-cart");
  const $headerCartHead   =   $(".js-header-cart-head");
  const $headerCartBody   =   $(".js-header-cart-body");
  const $headerCartFooter =   $(".js-header-cart-footer");
  const $headerCartEmpty  =   $(".js-header-cart-empty");
  const headerCartHeadHeight  =    $headerCartHead.height();
  const headerCartFooterHeight=   $headerCartFooter.height();
  // header Search
  const $headerSearch         =   $(".js-header-search");
  const $headerSearchBlock    =   $(".js-header-search-block");
  const $headerSearchContainer = $(".js-header-search-container");
  const headerSearchHeight = $headerSearch.height();
  // header Account
  const $headerAccount = $(".js-header-account");
  // header Login
  const $headerLogin = $(".js-header-login");

  const topWithPreheader =    preheaderHeight - scrollValue > 0 ? preheaderHeight - scrollValue : 0;

  $header.css("top", topWithPreheader);
  $headerCatalog.css("top", topWithPreheader + headerHeight + 12);
  $('.snize-ac-results').css("top", topWithPreheader + $header.height());

  console.log ( 'topWithPreheader', topWithPreheader );
});

const topBar = $("#shopify-section-top-bar");
const topNewHeader = $(".top-new-header");
if (topBar) {
  topBar.css("display", "block");
  const topBarHeight = topBar.height();
  const scrollValue = pageYOffset;
  const newTopValue =
    topBarHeight - scrollValue > 0 ? topBarHeight - scrollValue : 0;
  topNewHeader.css("top", newTopValue);
  window.addEventListener("scroll", function () {
    const scrollValue = pageYOffset;
    const newTopValue =
      topBarHeight - scrollValue > 0 ? topBarHeight - scrollValue : 0;
    topNewHeader.css("top", newTopValue);
  });
}

$(document).ready(function () {
    $(".js-custom-search-open").on("click", function (e) {
        console.log("test")
        e.preventDefault();
        console.log("test")
        var $header = $("#header");
        // var $headerSearchBlock = $(".js-header-search-block");
        var $headerSearch = $(".js-header-search");
        var $headerSearchInput = $(".js-header-search-input");
        var $headerSearchOverlay = $(".js-header-search-overlay");
        var $body = $("body");
        if (!$headerSearch.hasClass("active")) {
            // $headerSearchBlock.addClass("active");
            $headerSearch.addClass("active");
            $headerSearchInput.val("").trigger("change");
            $headerSearchOverlay.addClass("active");
            $header.css("z-index", 999);
            $body.css("overflow", "hidden")
        }
      
    });/* - - - - - - - - - - - - - -       header search close       - - - - - - - - - - - - - - - */
    $(".js-custom-search-close").on("click", function (e) {
        e.preventDefault();
        var $header = $("#header");
        // var $headerSearchBlock = $(".js-header-search-block");
        var $headerSearch = $(".js-header-search");
        var $headerSearchInput = $(".js-header-search-input");
        var $headerSearchOverlay = $(".js-header-search-overlay");
        var $body = $("body");
        if ($headerSearch.hasClass("active")) {
            // $headerSearchBlock.removeClass("active");
            $headerSearch.removeClass("active");
            $headerSearchInput.val("").trigger("change");
            $headerSearchOverlay.removeClass("active");
            $header.css("z-index", 100);
            $body.css("overflow", "auto")
        }
    });
    $(".js-header-search-input").on("change paste keyup input", function () {
        var $this = $(this);
        var $headerSearch = $(".js-header-search");
        // var $headerSeacrhInfo = $(".js-header-search-info");
        var $headerSearchClear = $(".js-header-search-clear");
        var $headerSearchInputBuffer = $(".js-header-search-input-buffer");
        // var $headerSearchNothing = $(".js-header-search-nothing");
        $headerSearchInputBuffer.text($this.val());
        // $headerSearchNothing.text("\"" + $this.val() + "\"");
        if ($this.val()) {
            $this.width($headerSearchInputBuffer.width() + 30);
            // $headerSeacrhInfo.addClass("show-result");
            $headerSearchClear.addClass("show")
        } else {
            if ($headerSearch.hasClass("active")) {
                $this.css("width", "auto")
            } else {
                $this.css("width", "100%")
            }
            // $headerSeacrhInfo.removeClass("show-result");
            $headerSearchClear.removeClass("show")
        }
    });/* - - - - - - - - - - - - - -       clear header search input       - - - - - - - - - - - - - - - */
    $(".js-header-search-clear").on("click", function (e) {
        e.preventDefault();
        var $headerSearchInput = $(".js-header-search-input");
        $headerSearchInput.val("").trigger("change")
    });

    $(document).on('click',function (event){
        if(event.target.className.includes('overlay-search overlay')){
            var $header = $("#header");
            // var $headerSearchBlock = $(".js-header-search-block");
            var $headerSearch = $(".js-header-search");
            var $headerSearchInput = $(".js-header-search-input");
            var $headerSearchOverlay = $(".js-header-search-overlay");
            var $body = $("body");
            if ($headerSearch.hasClass("active")) {
                // $headerSearchBlock.removeClass("active");
                $headerSearch.removeClass("active");
                $headerSearchInput.val("").trigger("change");
                $headerSearchOverlay.removeClass("active");
                $header.css("z-index", 100);
                $body.css("overflow", "auto")
            }
        }
    });

    $(".js-header-search-input").on("change paste keyup input", function () {
        var $headerSearchNothing = $(".snize-ac-results-content");
        var $headerSearchNothingImg = $(".header-search__info-nothing__img");
        console.log($headerSearchNothingImg)
        console.log($headerSearchNothingImg)
        if( $headerSearchNothingImg[0] == null && $headerSearchNothing[0] != null  ){
            $headerSearchNothing.prepend('<div class="header-search__info-nothing__img"> <img src="https://cdn.shopify.com/s/files/1/0062/7892/files/search.png?v=1643192061" alt=""> </div>');
            console.log("True")
        }else{
            console.log("False")
        }

    });

    $(document).on("click",'.js-cart-counter', function (e) {
        e.preventDefault();
        var $target = $(e.target);
        var $parent = $target.closest(".counter");
        var $counter = $parent.find("[data-context='counter']");
        var $minus = $parent.find("[data-context='minus']");
        var $counterValue = $counter.val();
        console.log($counterValue);
        var $targetData = $target.data("context");
        if (!$targetData) {
            $targetData = $target.parent().data("context")
        }
        if ($targetData == "minus") {
            if (Number($counterValue) > 1) {
                $counter.val("" + (Number($counterValue) - 1));// $counter.html(`${Number($counterValue) - 1}`);
                if ($counterValue - 1 <= 1) {
                    $minus.addClass("disable")
                }
            }
        } else if ($targetData == "plus") {
            $counter.val("" + (Number($counterValue) + 1));// $counter.html(`${Number($counterValue) + 1}`);
            if ($counterValue + 1 >= 1 && $minus.hasClass("disable")) {
                $minus.removeClass("disable")
            }
        }
    });
});



const $box = document.querySelectorAll('.accordion-title');
const $boxInners = document.querySelectorAll('.main-faq__info-list .accordion-body p ');
const $boxTitles = document.querySelectorAll('.main-faq__info-list .title h3 ');
const $search = document.querySelector('.js-faq-search-input');
if($search != null){
$search.addEventListener('input', (event) => {
    setInnerHtmlForElements($box);
    setInnerHtmlForElements($boxInners);
    setInnerHtmlForElements($boxTitles);
    function setInnerHtmlForElements(arr) {
      arr.forEach(elem => {
          const searchText = event.target.value;
          const regex = new RegExp(searchText, 'gi');
          let text = elem.innerText;
          text = text.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
          const newText = text.replace(regex, '<mark class="highlight">$&</mark>');
          elem.innerHTML = newText;
      })

  }
    const $mark = document.querySelector('mark')
    const $noFound = document.querySelector('.main-faq__info-nothing')
    if ($mark) {
        $noFound.style.display = 'none';
    } else {
        $noFound.style.display = 'flex';
    }
    const btnClear = document.querySelector('.main-faq__info-search__input-clear')
    btnClear.addEventListener('click', function () {
        $noFound.style.display = 'none';
        const $markList = document.querySelectorAll('mark')
        $markList.forEach((item) => {
            item.style.background = 'transparent'
        })
    })
});}


$(function() {
    $(".contact-form-btn").on("click", validate);

    // Validate email
    function validateEmail(email) {
        var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return re.test(String(email).toLowerCase());
    }
    // validate email and send form after success validation
    function validate() {
        var email = $(".email").val();
        var $error = $(".form-alert");
        if (validateEmail(email)) {
            $error.hide();
            document.getElementById('contact_form').submit();
        } else {
            $error.css('display', 'flex');
        }
        return false;
    }
});

// Main product compare elements the same state
$('.main-product__actions-bar .js-compare-wrapper').on('click', function() {
    $('.js-compare-wrapper.main-product__actions-content').toggleClass('show-icon');
    $('.js-compare-wrapper.main-product__actions-content').find('.js-compare-element').toggleClass('in-comparison');
});

$('.js-compare-wrapper.main-product__actions-content').on('click', function() {
    $('.main-product__actions-bar .js-compare-wrapper').toggleClass('show-icon');
    $('.main-product__actions-bar .js-compare-wrapper').find('.js-compare-element').toggleClass('in-comparison');
});


function setCountComparableItems ( wrapper, element ) {
    let showIconCount = $(wrapper);

    if ( $(element).length === 0 ) {
        showIconCount.addClass('hidden');
    } else {
        showIconCount.removeClass('hidden');
        showIconCount.text( $(element).length );
    }
}

$('.js-compare-wrapper').on('click', function() {
    setTimeout(()=> {
        let comparableProducts = JSON.parse(localStorage.getItem('comparableProducts'));
        setCountComparableItems($('.js-header-comparer-desk .header-container__info__item-count'), comparableProducts );
        setCountComparableItems($('.js-header-comparer-mob .header-container__info__item-count'), comparableProducts );
    },700)
});

$(document).ready(function () {
    setTimeout(function(){
        let comparableProducts = JSON.parse(localStorage.getItem('comparableProducts'));
        setCountComparableItems($('.js-header-comparer-desk .header-container__info__item-count'), comparableProducts );
        setCountComparableItems($('.js-header-comparer-mob .header-container__info__item-count'), comparableProducts );
    },700)

    $(document).on('click', '.product-view .comparable-custom-action', function() {
        let handle = $(this).closest('.product-view__info__body-container').find('.add-to-comparable').attr('data-product');
        $(`.product-box .add-to-comparable[data-product="${handle}"]`).removeClass('in-comparison');
    });
    $(document).on("click",".js-product-card-menu-toogle", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.closest(".product-box__actions");
        $(".product-box__actions").removeClass("active");
        $parent.addClass("active")
    });
    $(document).on("click", "*", function (e) {
        var $target = e.target;
        var $actions = $(".product-box__actions");
        if (!$actions.is($target) && $actions.has($target).length === 0) {
            $actions.removeClass("active")
        }
    });
    $(document).on('click','.success_popup-close',function (){
        $('.success_popup').addClass('hidden');
    })

    window.addEventListener("scroll", function () {
        success_popup_position();
    });
    success_popup_position();
    function success_popup_position(){
        var product_success_popup=$('.success_popup');
        var $preheader = $("#preheader");
        var $productFixed = $(".js-product-fixed.show");
        var productFixedHeight = $productFixed.length != 0 ? $productFixed.height() : 0;
        var preheaderHeight = $preheader.height();// scroll value
        var scrollValue = window.pageYOffset;// main
        var topWithPreheader = preheaderHeight - scrollValue > 0 ? preheaderHeight - scrollValue : 0;
        if ( window.matchMedia('(max-width: 991px)' ).matches ) {
            product_success_popup.css("top", topWithPreheader + 90);
        } else {
            product_success_popup.css("top", topWithPreheader + productFixedHeight + 110);
        }

    }

});

$('.js-catalog-filter-toggle').on('click',function (){
    $('.filter-body__inner .filter-box').toggleClass('active')
})

$( document )
.on(`click`, `a[href="/pages/compare"]`, function( e ) {
    try {
        e.stopImmediatePropagation();
        e.preventDefault();
        let getComparableProducts = localStorage.getItem( `comparableProducts` );
        if ( typeof getComparableProducts !== 'undefined' && getComparableProducts ) {
            getComparableProducts = JSON.parse( getComparableProducts );
            if ( getComparableProducts.length > 0 ) {
                location.href = `/pages/compare`;
            } else {
                location.href = `/collections/all`;
            }
            console.log ( 'getComparableProducts', getComparableProducts );
        }
    } catch ( err ) {
        console.log( `ERROR a[href="/pages/compare"]`, err.message );
    }
})
;